@include base-component();

.calendar {
  @apply mb-1;
}

.week-headers {
  @apply border-color-3
    flex
    border-0
    border-t
    border-solid
    py-0
    px-1;
}

.week-header {
  @apply text-color-3
    text-center
    font-bold;
  inline-size: calc(100% / 7);
}

.day {
  @apply flex
  min-w-0
  justify-center;
  inline-size: 100%;
  calcite-date-picker-day {
    @apply w-full;
  }
}

:host([scale="s"]) .week-header {
  @apply text-n2h px-0 pt-2 pb-3;
}

:host([scale="m"]) .week-header {
  @apply text-n2h px-0 pt-3 pb-4;
}

:host([scale="l"]) .week-header {
  @apply text-n1h px-0 pt-4 pb-5;
}

.week-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: 1fr;
  padding-block: 0;
  padding-inline: 6px;
  &:focus {
    @apply outline-none;
  }
}
